import { useEffect, useRef, useState } from "react";
import { isClassScheduleFilterActive } from "helpers/jackrabbit/classScheduleFilter";

const DEFAULT_SETTLE_MS = 900;

/**
 * Waits until the user pauses changing filters before treating the search as final.
 * Clears, inactive filters, and the first apply after resetKey changes are immediate.
 */
const useDebouncedScheduleFilter = (
  filter,
  { settleMs = DEFAULT_SETTLE_MS, resetKey = "" } = {}
) => {
  const [settledFilter, setSettledFilter] = useState(filter);
  const skipDebounceOnceRef = useRef(true);

  useEffect(() => {
    skipDebounceOnceRef.current = true;
  }, [resetKey]);

  useEffect(() => {
    if (!isClassScheduleFilterActive(filter)) {
      setSettledFilter(filter);
      return undefined;
    }

    if (skipDebounceOnceRef.current) {
      skipDebounceOnceRef.current = false;
      setSettledFilter(filter);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setSettledFilter(filter);
    }, settleMs);

    return () => window.clearTimeout(timer);
  }, [filter, settleMs, resetKey]);

  const isSettling =
    isClassScheduleFilterActive(filter) &&
    JSON.stringify(filter) !== JSON.stringify(settledFilter);

  return { settledFilter, isSettling };
};

export default useDebouncedScheduleFilter;
